import { toast } from 'react-toastify';
import { setIsLoading, setRemoveLoading, setShowPopupDetail, setShowRemovePopup } from '../../../../../actions/general';
import { callApi } from '../../../../../apiCaller';
import {
     API_SUBSCRIBER_ASSIGN_BUNDLE_SEATS,
     API_SUBSCRIBER_REMOVE_ASSIGNED_BUNDLE_SEAT,
     DEFAULT_PAGINATION_SEAT_TABLE_INIT,
     ORG_MEMBER_DEFAULT,
     SEAT_STATUS,
     SEAT_STEPS,
     TRAINING_PRODUCT_TYPES,
     API_SUBSCRIBER_LIST_ORGANIZATION_BUNDLE_SEATS,
} from '../../../../../constants';
import { checkCeProductIsRPT, cloneDeep, generateId, toastError, validateEmail } from '../../../../../utils';
import { deleteActiveSeatByUser } from '../../../Subscriber/GlobalStates/Seat/actions';
import { setOrganizationMembers, updateOrganizationMember } from '../../OrganizationMembers/actions';
import { setListOrganizationBundleSeats, setListOrganizationSeats, setOrganizationSeatsFilter } from '../OrganizationSeats/actions';

export const assignSeatRequest = (newValues, nextDispatch) => (dispatch, getState) => {
     const organizationMemberUsers = cloneDeep(getState().subscriber.organizationMembers);
     const organizationSeatsFilter = cloneDeep(getState().subscriber.organizationSeatsFilter);
     const listOrganizationSeats = cloneDeep(getState().subscriber.listOrganizationSeats);

     const { setValidateOnChange, setSubmitting, fetchOrgSeats, setPagination } = nextDispatch;

     callApi(API_SUBSCRIBER_ASSIGN_BUNDLE_SEATS, 'POST', newValues)
          .then((response) => {
               setSubmitting(false);
               setValidateOnChange(false);

               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const organizationSeatRes = response.data;

               // Define message from server
               if (organizationSeatRes.message && organizationSeatRes.message !== 'Success') {
                    toast.error(organizationSeatRes.message);
                    return;
               }

               // Update organization seats
               const organizationSeatUpdated = organizationSeatRes.items[0];

               // Reset filter table
               const paginationPayload = {
                    ...DEFAULT_PAGINATION_SEAT_TABLE_INIT,
               };
               setPagination((currentPagination) => {
                    paginationPayload.pageSize = currentPagination.pageSize;

                    return paginationPayload;
               });
               fetchOrgSeats(paginationPayload);

               if (organizationSeatsFilter?.length) {
                    for (let i = 0; i < organizationSeatsFilter.length; i++) {
                         const orgSeat = organizationSeatsFilter[i];

                         if (orgSeat?.id === organizationSeatUpdated?.id) {
                              organizationSeatsFilter[i] = { ...organizationSeatUpdated };
                              break;
                         }
                    }
               }

               dispatch(setOrganizationSeatsFilter(organizationSeatsFilter));

               listOrganizationSeats?.forEach((seat) => {
                    if (seat.id === organizationSeatUpdated?.id) {
                         seat.status = SEAT_STATUS.RESERVED;
                    }
               });
               dispatch(setListOrganizationSeats(listOrganizationSeats));

               // Update organization member users
               if (organizationSeatUpdated?.user) {
                    const userMember = organizationMemberUsers?.find((item) => item.email === organizationSeatUpdated.user.email);

                    if (userMember) {
                         const memberSeatUser = userMember.numberOfSeatUsed ? Number(userMember.numberOfSeatUsed) : 0;
                         userMember.numberOfSeatUsed = memberSeatUser + 1;
                         dispatch(updateOrganizationMember(userMember));
                    }
               }

               // Update organization members
               const checkMemberOrganization = organizationMemberUsers?.filter(
                    (orgMemberUser) => orgMemberUser.email === organizationSeatRes.items[0].emailInvite
               );

               if (checkMemberOrganization && !checkMemberOrganization.length) {
                    const newOrgMember = [
                         {
                              ...ORG_MEMBER_DEFAULT,
                              id: organizationSeatUpdated?.user?.id || generateId(), // no remove generate id here
                              token: organizationSeatUpdated?.user ? '' : organizationSeatUpdated?.token,
                              email: newValues.emails[0],
                              firstName: organizationSeatUpdated?.user?.firstName,
                              lastName: organizationSeatUpdated?.user?.lastName,
                              orgUserId: generateId(),
                              numberOfSeatUsed: 1,
                         },
                    ];
                    dispatch(setOrganizationMembers([...organizationMemberUsers, ...newOrgMember]));
               }

               toast.success('Seat assignment successfully');
          })
          .finally(() => {
               dispatch(setShowPopupDetail(null));
          });
};

export const assignMultipleSeatsRequest = (newValues, nextDispatch) => (dispatch, getState) => {
     const products = cloneDeep(getState().subscriber.products.list);
     const organizationSeatsFilter = cloneDeep(getState().subscriber.organizationSeatsFilter);
     const organizationMemberUsers = cloneDeep(getState().subscriber.organizationMembers);
     const listOrganizationSeats = cloneDeep(getState().subscriber.listOrganizationSeats);

     const { organizationId, organizationProductId, seats, emails } = newValues;
     const { setCurrentStep, setSeatAssignmentResults, setIsSubmitting, productId, setPagination, fetchOrgSeats } = nextDispatch;

     const newEmails = [];
     const emailErrors = [];
     const emailsAlreadyAssigned = [];

     setIsSubmitting(true);

     const product = products.find((prod) => prod.id === productId);
     const checkCeProduct = product && checkCeProductIsRPT(product, products);
     const isPhysicalProduct = product?.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.PHYSICAL_PRODUCT;
     const isPurchaseDigital = product?.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.PURCHASE_DIGITAL_DOWNLOAD;

     for (let i = 0; i < emails.length; i++) {
          const email = emails[i].toLowerCase().trim();

          if (!email) {
               continue;
          }

          if (!validateEmail(email)) {
               emailErrors.push(email);
               continue;
          }

          if (isPhysicalProduct || checkCeProduct || isPurchaseDigital) {
               newEmails.push(email);
               continue;
          }

          // Seat already exist & email already exists in seat
          const emailAlreadyAssignedExist =
               newEmails.some((emailItem) => emailItem === email) || emailsAlreadyAssigned.some((emailAssigned) => emailAssigned === email);

          if (emailAlreadyAssignedExist) {
               emailErrors.push(email);
               continue;
          }

          const seatAlreadyExist = seats.some((seat) => seat.email?.toLowerCase() === email && seat.status === SEAT_STATUS.RESERVED);

          if (seatAlreadyExist) {
               emailsAlreadyAssigned.push(email);
               continue;
          }

          newEmails.push(email);
     }

     if (!newEmails.length) {
          setSeatAssignmentResults((prevSeatAssignmentResults) => {
               return {
                    ...prevSeatAssignmentResults,
                    failed: {
                         ...prevSeatAssignmentResults.failed,
                         items: emailErrors,
                    },
                    alreadyAssigned: {
                         ...prevSeatAssignmentResults.alreadyAssigned,
                         items: emailsAlreadyAssigned,
                    },
               };
          });

          setCurrentStep(SEAT_STEPS.SEAT_ASSIGNMENT_COMPLETE);
          setIsSubmitting(false);
          return;
     }

     const assignMultipleSeatPayload = {
          emails: newEmails,
          organizationId,
          organizationProductId,
     };

     callApi(API_SUBSCRIBER_ASSIGN_BUNDLE_SEATS, 'POST', assignMultipleSeatPayload).then((response) => {
          setIsSubmitting(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const organizationSeatsUpdated = response.data.items;

          const {
               successfully: successfullyItems,
               failed: failedItems,
               hasAwaitingItem: hasAwaitingItems,
               alreadyAssigned: alreadyAssignedItems,
               alreadyAccessCourse: alreadyAccessCourseItems,
               alreadyCompletedCourse: alreadyCompletedCourseItems,
          } = response.data.result;

          setCurrentStep(SEAT_STEPS.SEAT_ASSIGNMENT_COMPLETE);

          setSeatAssignmentResults((prevSeatAssignmentResults) => {
               return {
                    ...prevSeatAssignmentResults,
                    ...(successfullyItems.length && {
                         successfully: {
                              ...prevSeatAssignmentResults.successfully,
                              items: successfullyItems,
                         },
                    }),
                    ...((emailErrors.length || failedItems.length) && {
                         failed: {
                              ...prevSeatAssignmentResults.failed,
                              items: [...emailErrors, ...failedItems],
                         },
                    }),
                    ...(hasAwaitingItems.length && {
                         hasAwaitingItem: {
                              ...prevSeatAssignmentResults.hasAwaitingItem,
                              items: hasAwaitingItems,
                         },
                    }),
                    ...((emailsAlreadyAssigned.length || alreadyAssignedItems.length) && {
                         alreadyAssigned: {
                              ...prevSeatAssignmentResults.alreadyAssigned,
                              items: [...emailsAlreadyAssigned, ...alreadyAssignedItems],
                         },
                    }),
                    ...(alreadyAccessCourseItems.length && {
                         alreadyAccessCourse: {
                              ...prevSeatAssignmentResults.alreadyAccessCourse,
                              items: alreadyAccessCourseItems,
                         },
                    }),
                    ...(alreadyCompletedCourseItems.length && {
                         alreadyCompletedCourse: {
                              ...prevSeatAssignmentResults.alreadyCompletedCourse,
                              items: alreadyCompletedCourseItems,
                         },
                    }),
               };
          });

          // Update organization seats
          if (organizationSeatsFilter?.length) {
               for (let i = 0; i < organizationSeatsFilter.length; i++) {
                    const orgSeat = organizationSeatsFilter[i];
                    const orgSeatUpdated = organizationSeatsUpdated.find((orgSeatUpdated) => orgSeatUpdated.id === orgSeat.id);

                    if (orgSeat.id === orgSeatUpdated?.id) {
                         organizationSeatsFilter[i] = { ...orgSeatUpdated };
                    }
               }
          }

          dispatch(setOrganizationSeatsFilter(organizationSeatsFilter));

          listOrganizationSeats?.forEach((seat) => {
               const orgSeatUpdated = organizationSeatsUpdated.find((orgSeatUpdated) => orgSeatUpdated.id === seat.id);
               if (seat.id === orgSeatUpdated?.id) {
                    seat.status = SEAT_STATUS.RESERVED;
               }
          });
          dispatch(setListOrganizationSeats(listOrganizationSeats));

          // Update organization member users
          for (let i = 0; i < organizationSeatsUpdated.length; i++) {
               const orgSeatUpdated = organizationSeatsUpdated[i];

               if (!orgSeatUpdated.user) {
                    continue;
               }

               const userMember = organizationMemberUsers?.find(
                    (organizationMemberUser) => organizationMemberUser.email === orgSeatUpdated.user.email
               );

               if (userMember) {
                    const memberSeatUser = userMember.numberOfSeatUsed ? Number(userMember.numberOfSeatUsed) : 0;
                    userMember.numberOfSeatUsed = memberSeatUser + 1;

                    dispatch(updateOrganizationMember(userMember));
               }
          }

          // Update organization members
          const newOrgMember = [];
          for (let i = 0; i < successfullyItems.length; i++) {
               const email = successfullyItems[i];
               const orgMemberExist = organizationMemberUsers?.some((organizationMemberUser) => organizationMemberUser.email === email);

               if (orgMemberExist) {
                    continue;
               }

               const organizationSeat = organizationSeatsUpdated.find((organizationSeatItem) => organizationSeatItem?.user?.email === email);
               const orgIndex = newOrgMember.findIndex((item) => item.email === email);

               if (orgIndex > -1) {
                    newOrgMember[orgIndex].numberOfSeatUsed += 1;
               } else {
                    newOrgMember.push({
                         ...ORG_MEMBER_DEFAULT,
                         email,
                         firstName: organizationSeat?.user?.firstName,
                         lastName: organizationSeat?.user?.lastName,
                         orgUserId: generateId(),
                         numberOfSeatUsed: 1,
                    });
               }
          }

          if (organizationMemberUsers?.length) {
               dispatch(setOrganizationMembers([...organizationMemberUsers, ...newOrgMember]));
          }

          // Reset filter table
          const paginationPayload = {
               ...DEFAULT_PAGINATION_SEAT_TABLE_INIT,
          };
          setPagination((currentPagination) => {
               paginationPayload.pageSize = currentPagination.pageSize;

               return paginationPayload;
          });
          fetchOrgSeats(paginationPayload);
     });
};

export const removeBundleSeatRequest = (values, seatId, fetchOrgSeats, setPagination) => (dispatch, getState) => {
     const listOrganizationBundleSeats = cloneDeep(getState().subscriber.listOrganizationBundleSeats);

     const organizationMemberUsers = cloneDeep(getState().subscriber.organizationMembers);

     dispatch(setRemoveLoading(true));
     callApi(API_SUBSCRIBER_REMOVE_ASSIGNED_BUNDLE_SEAT.replace(':id', seatId), 'DELETE', values)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               // Update list active seat by user
               dispatch(deleteActiveSeatByUser(seatId));

               // Update organization seats
               const organizationSeatUpdated = response.data;

               // Reset filter table
               const paginationPayload = {
                    ...DEFAULT_PAGINATION_SEAT_TABLE_INIT,
               };
               setPagination((currentPagination) => {
                    paginationPayload.pageSize = currentPagination.pageSize;

                    return paginationPayload;
               });
               fetchOrgSeats(paginationPayload);

               listOrganizationBundleSeats?.forEach((seat, index, object) => {
                    if (seat.id === organizationSeatUpdated?.id) {
                         seat.status = SEAT_STATUS.OPEN;

                         if (organizationSeatUpdated.productCredit) {
                              object.splice(index, 1);
                         }
                    }
               });

               dispatch(setListOrganizationBundleSeats(listOrganizationBundleSeats));

               // Update organization member users
               if (values.email) {
                    const userMember = organizationMemberUsers?.find((orgMember) => orgMember.email === values.email);

                    if (userMember) {
                         const memberSeatUser = userMember.numberOfSeatUsed ? Number(userMember.numberOfSeatUsed) : 0;
                         const newSeatUsed = memberSeatUser - 1;

                         userMember.numberOfSeatUsed = newSeatUsed > 0 ? newSeatUsed : 0;
                         dispatch(updateOrganizationMember(userMember));
                    }
               }

               toast.success('Remove user successfully');
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const fetchOrganizationSeatsByFilterRequest =
     ({ organizationId, query, setOrgNotCourses, setOrgUserSeats }) =>
     async (dispatch) => {
          let urlApi = `${API_SUBSCRIBER_LIST_ORGANIZATION_BUNDLE_SEATS.replace(':organizationId', organizationId)}`;

          // Add query into url api
          if (Object.keys(query).length > 0) {
               const queryArray = [];

               Object.keys(query).forEach((key) => {
                    if (query[key]) {
                         queryArray.push(`${key}=${query[key]}`);
                    }
               });

               if (queryArray.length > 0) {
                    urlApi += '?' + queryArray.join('&');
               }
          }

          dispatch(setIsLoading(true));
          return await callApi(urlApi, 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         if (typeof setOrgUserSeats === 'function') {
                              setOrgUserSeats(response.data);
                         } else {
                              dispatch(setOrganizationSeatsFilter(response.data));
                         }

                         if (!response.data.length && typeof setOrgNotCourses === 'function') {
                              setOrgNotCourses(true);
                         }
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    dispatch(setIsLoading(false));
               });
     };
